import type {
  CollectionCardItem,
  KyrgyzstanCollectionItem,
} from 'entities/kyrgyzstan'

export const getCollectionCardItems = (
  collection: KyrgyzstanCollectionItem,
): CollectionCardItem[] =>
  collection.results.map(({ realty_object: realtyObject }) => ({
    id: realtyObject.id,
    title: realtyObject.title,
    images: realtyObject.images,
    type: realtyObject.type,
    price: Number(realtyObject.price) || 0,
    collectionPreset: {
      visitors_count: collection.visitors_count,
      start_date: collection.start_date,
      end_date: collection.end_date,
    },
  }))
